module.exports = __webpack_public_path__ + "img/changeColor-1.068df9e.png";